export default [
  {
    path: '/contratos',
    name: 'contratos',
    component: () => import(/* webpackChunkName: "contratos" */ '../../views/contratos/MeuPlano')
  },
  {
    path: '/contratos/alterar',
    name: 'alterar-plano-contrato',
    component: () => import(/* webpackChunkName: "alterar-plano-contrato" */ '../../views/contratos/AlterarPlanoContrato')
  }
]
